export const TIPI_PROPRIETA_ARTICOLO_LIST: any[] = JSON.parse(
  '[ {"id" : 1 , "descrizione" : "Alfanumerico" }, {"id" : 2 , "descrizione" : "Numero" }, {"id" : 3 , "descrizione" : "Data" }, {"id" : 4 , "descrizione" : "Selezione multipla" }]',
);
export const TIPO_PROPRIETA_ARTICOLO_ALFANUMERICO = 1;
export const TIPO_PROPRIETA_ARTICOLO_NUMERO = 2;
export const TIPO_PROPRIETA_ARTICOLO_DATA = 3;
export const TIPO_PROPRIETA_ARTICOLO_SELMULTI = 4;
